'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _tag = require('../tag');

var _tag2 = _interopRequireDefault(_tag);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var cx = _bind2.default.bind(_style2.default);

var TagSelector = function TagSelector(_ref) {
  var items = _ref.items,
      fields = _ref.fields,
      disabled = _ref.disabled;
  var selectedItems = fields.getAll() || [];
  return _react2.default.createElement('div', {
    className: cx('xsui-tag-selector')
  }, items.filter(function (a) {
    return a.required;
  }).sort(function (a, b) {
    return a.label.localeCompare(b.label);
  }).map(function (item) {
    return _react2.default.createElement('div', {
      key: 'locale--' + item.label,
      className: cx('xsui-tag-selector__item')
    }, _react2.default.createElement(_tag2.default, {
      selected: true,
      disabled: disabled,
      value: item.value
    }, item.label));
  }), items.filter(function (a) {
    return !a.required;
  }).map(function (item) {
    return _extends({}, item, {
      selected: selectedItems.includes(item.value)
    });
  }).sort(function (a, b) {
    return b.selected - a.selected || a.label.localeCompare(b.label);
  }).map(function (item) {
    return _react2.default.createElement('div', {
      key: 'locale--' + item.label,
      className: cx('xsui-tag-selector__item')
    }, _react2.default.createElement(_tag2.default, {
      selected: item.selected,
      disabled: disabled,
      value: item.value,
      onClick: item.selected ? fields.remove.bind(undefined, selectedItems.indexOf(item.value)) : fields.push.bind(undefined, item.value)
    }, item.label));
  }));
};

TagSelector.propTypes = {
  fields: _propTypes2.default.object,
  disabled: _propTypes2.default.bool,
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.any.isRequired,
    required: _propTypes2.default.bool
  }))
};
TagSelector.defaultProps = {
  disabled: false,
  items: []
};
exports.default = TagSelector;